import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 0 10%;
  padding-top: 3.2em;
  display: flex;
  align-items: end;




  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding-top: 2.5em;
    justify-content: center;
  }

`;
